define('presentation/settings/userSubscriptions/presentationObjects/userVoicemailSubscription',[],function() {
    return function(){
        let self = this;

        self.voicemailBoxId = null;
        self.voicemailBoxName = null;
        self.voicemailBoxType = null;
        self.userAvatar = ko.observable();
        self.userId = null;
        self.userGroupId = null;
        self.isEmailDeliveryEnabled = ko.observable().extend({observeState: true});
        self.isShowInSidebarEnabled = ko.observable().extend({observeState: true});
        self.isPushToMobileAppEnabled = ko.observable().extend({observeState: true});
        self.subscribers = [];
        self.showSubscribers = ko.observable(false).toggleable();
    };
});

